import { _ } from "../../../../core/polyglot/polyglot.js";
import AccountingDocumentWidget from "../../../shared/documentInfrastructure/AccountingDocumentWidget.js";
import TitleWidget from "../../../../core/chrome/TitleWidget2.js";

/**
 * Render the document's title for the forecast viewer.
 */
export default class ForecastViewerTitleWidget extends AccountingDocumentWidget {
	setup(...rest) {
		super.setup(...rest);

		this._title = new TitleWidget({
			title: this._documentState.getForecastName(),
			subtitle: (html) => this._renderSubtitleOn(html),
		});
	}

	setSaveSpaceMode(isInSaveSpaceMode) {
		this._isInSaveSpaceMode = isInSaveSpaceMode;
		this.update();
	}

	renderContentOn(html) {
		if (!this._title) return;
		html.render(this._title);
	}

	_renderSubtitleOn(html) {
		const forecastCurrentPeriod = this._documentState
			.getCurrentPeriod()
			.asString();

		const forecastTemplateName =
			this._documentState.getForecastTemplateName();

		html.render(
			forecastTemplateName
				? _(
						"Published from the template {name} based on actuals until {period}",
						{
							name: forecastTemplateName,
							period: forecastCurrentPeriod,
						},
					)
				: _("Forecast based on actuals until {period}", {
						period: forecastCurrentPeriod,
					}),
		);
	}
}
